module.exports = __webpack_public_path__ + "img/bannerRed.81b64dd0.jpg";